export const parseProductIdVendorId = (id: string) => {
  let vendorId: number | undefined;
  let productId: number | undefined;
  // Chrome
  let matches = id.match(/Vendor: ([a-z0-9A-Z]+)/);
  if (matches) {
    vendorId = parseInt(matches[1], 16);
  }
  matches = id.match(/Product: ([a-z0-9A-Z]+)/);
  if (matches) {
    productId = parseInt(matches[1], 16);
  }

  // FF
  if (!productId && !vendorId) {
    //54c-9cc-Wireless Controller
    matches = id.match(/^([a-z0-9A-Z]+)-([a-z0-9A-Z]+)-.*$/);
    if (matches) {
      vendorId = parseInt(matches[1], 16);
      productId = parseInt(matches[2], 16);
    }
  }
  return { productId, vendorId };
};
